import { module } from 'angular';
import {
  BusinessRegistrationFormComponent,
  CandidateRegistrationFormComponent,
  EmployerRegistrationFormComponent,
  LoginComponent,
  PasswordRecoveryComponent,
  RegisterAsComponent,
  RegistrationComponent
} from './components';
import { authRoutesConfig } from './auth-routing';
import { AuthComponent } from './auth.component';
import { AccountActivationComponent } from './components/account-activation/account-activation.component';
import { AuthActivationInfoComponent } from './components/auth-activation-info/auth-activation-info.component';
import { AuthActivationCandidateInfoComponent } from './components/auth-activation-info/auth-activation-candidate-info.component';
import { authGuard } from './auth.guard';

export const AuthModule = module('app.states.auth', [])
  .component('auth', AuthComponent)
  .component('login', LoginComponent)
  .component('registration', RegistrationComponent)
  .component('passwordRecovery', PasswordRecoveryComponent)
  .component('accountActivation', AccountActivationComponent)
  .component('authActivationInfo', AuthActivationInfoComponent)
  .component('authActivationCandidateInfo', AuthActivationCandidateInfoComponent)
  .component('registerAs', RegisterAsComponent)
  .component('businessRegistrationForm', BusinessRegistrationFormComponent)
  .component('employerRegistrationForm', EmployerRegistrationFormComponent)
  .component('candidateRegistrationForm', CandidateRegistrationFormComponent)
  .config(authRoutesConfig)
  .run(authGuard);



// WEBPACK FOOTER //
// ./app/states/auth/auth.module.ts